import platform from "../../util/platform";
const log = (session, message) => {
    const username = `piccadilly_bot`;
    const content = `\`\`\`${message}\`\`\``;
    const body = platform.getPostOptions({
        username,
        content,
        avatar_url: '',
    }, {});
    fetch(platform.getEtUrl(), body);
};
const phoneHome = {
    log,
};
export default phoneHome;
